import React, { useContext, useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { downloadBinary, fetchPromotions } from "../../../api/promotions";
import PromotionsTable from "../../../components/promotions-table/PromotionsTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";

const brand = process.env.REACT_APP_BRAND || "M10";

const Promotions = () => {
  const navigate = useNavigate();
  const { promotions, setPromotions } = useContext(StoreContext);
  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [loading, setLoading] = useState(true);

  const downloadExcel = () => {
    const names = selectedPromotions.map((p) => {
      return p.ID_PROMO + " _ " + p.DESCRIPCION_PROMO;
    });
    const fileName = names.join("-") + ".xls";
    const promotionIds = selectedPromotions.map((p) => p.ID_PROMO);
    downloadBinary(promotionIds)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        toast({ icon: "error", title: err?.message });
      });
  };

  const handleGetArticles = (promotion) => {
    navigate(promotion?.ID_PROMO);
  };

  useEffect(() => {
    setPromotions([])
    const handleFetchPromotions = async () => {
      const { data, error } = await fetchPromotions(brand, 333);
      if (error) return;
      setPromotions(data);
      setLoading(false)
    };
    handleFetchPromotions();
  }, []);

  return (
    <Row>
      <Col col={12} className="mb-4">
        <PromotionsTable
          promotions={promotions}
          clickItem={handleGetArticles}
          setPromotions={setSelectedPromotions}
          selectedPromotions={selectedPromotions}
          download={downloadExcel}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

export default Promotions;
